import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

const plans = [
  {
    name: 'スターター',
    price: '50,000',
    unit: '円/月（税別）',
    description: 'まずは営業支援を試してみたい方に最適なエントリープラン',
    features: [
      '営業戦略の初回診断',
      '月1回の営業レポート提出',
      'メールサポート（平日9:00〜18:00）',
      '基本的な営業資料テンプレート提供',
      '初期契約期間：3ヶ月〜',
    ],
    accent: false,
  },
  {
    name: 'スタンダード',
    price: '150,000',
    unit: '円/月（税別）',
    description: '本格的な営業支援とコンサルティングをお求めの企業様に',
    features: [
      '営業戦略の設計・実行支援',
      '週次での営業進捗レポート',
      '専任担当者による電話・メールサポート',
      '営業資料の作成代行（月5本まで）',
      '月1回のオンライン戦略会議',
      '簡易CRMツールの提供',
      '初期契約期間：6ヶ月〜',
    ],
    accent: true,
    recommended: true,
  },
  {
    name: 'プレミアム',
    price: '300,000',
    unit: '円/月（税別）',
    description: '営業組織全体の抜本的な変革と成長を目指す企業様に',
    features: [
      '営業戦略の全面的な設計・実行支援',
      'リアルタイムでの営業データ分析・ダッシュボード提供',
      '専任チーム（3名以上）によるフルサポート',
      '営業資料の作成代行（無制限）',
      '週1回のオンライン戦略会議',
      '営業研修・トレーニングの定期実施',
      'システム導入・インテグレーション支援',
      '経営層向け月次レポート提出',
      '初期契約期間：12ヶ月〜',
    ],
    accent: false,
  },
];

const faqs = [
  {
    q: '契約期間の縛りはありますか？',
    a: '各プランに初期契約期間を設けております。スターターは3ヶ月、スタンダードは6ヶ月、プレミアムは12ヶ月となります。期間満了後は1ヶ月ごとの自動更新となります。',
  },
  {
    q: '業種や業界に制限はありますか？',
    a: '特に制限はございません。BtoB、BtoC問わず、幅広い業種・業界からのご相談に対応しております。まずはお気軽にご相談ください。',
  },
  {
    q: '追加のオプションサービスはありますか？',
    a: 'はい、各プランに加えて、スポットでの営業研修やシステム開発、販売代行なども承っております。詳細はお問い合わせください。',
  },
  {
    q: '解約時の手続きはどのようになりますか？',
    a: '契約期間満了の1ヶ月前までにご連絡いただければ、解約手数料等は発生いたしません。契約期間中の解約については、別途ご相談となります。',
  },
];

export default function PricingPage() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <main>
        <section className="w-full pt-28 pb-20 md:pt-32 md:pb-28 bg-background-50">
          <div className="max-w-6xl mx-auto px-4 md:px-6">
            <div className="text-center mb-14">
              <p className="text-primary-600 text-sm font-medium tracking-widest mb-3">PRICING</p>
              <h1 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-4">
                料金プラン
              </h1>
              <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto leading-relaxed">
                御社の規模やニーズに合わせて、最適なプランをお選びいただけます。
                すべてのプランに無料の初回相談が付いています。
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
              {plans.map((plan, idx) => (
                <div
                  key={idx}
                  className={`relative rounded-lg border-2 p-6 md:p-8 transition-all duration-300 ${
                    plan.accent
                      ? 'border-primary-500 bg-primary-50/30 scale-[1.02] md:scale-105'
                      : 'border-background-200/70 bg-background-50 hover:border-primary-200'
                  }`}
                >
                  {plan.recommended && (
                    <div className="absolute -top-3.5 left-1/2 -translate-x-1/2 px-5 py-1.5 bg-primary-500 text-background-50 text-xs font-bold rounded-full whitespace-nowrap">
                      最も選ばれています
                    </div>
                  )}
                  <div className="text-center mb-7">
                    <h3 className="font-heading text-xl font-bold text-foreground-900 mb-3">{plan.name}</h3>
                    <div className="flex items-baseline justify-center gap-1 mb-3">
                      <span className="text-4xl md:text-5xl font-heading font-bold text-foreground-900">
                        ¥{plan.price}
                      </span>
                    </div>
                    <p className="text-sm text-foreground-500 mb-3">{plan.unit}</p>
                    <p className="text-xs text-foreground-500 leading-relaxed">{plan.description}</p>
                  </div>
                  <ul className="flex flex-col gap-3 mb-8">
                    {plan.features.map((feature, fidx) => (
                      <li key={fidx} className="flex items-start gap-2.5 text-sm text-foreground-700">
                        <i className={`ri-checkbox-circle-fill mt-0.5 flex-shrink-0 text-base ${plan.accent ? 'text-primary-500' : 'text-accent-500'}`} />
                        <span className="leading-relaxed">{feature}</span>
                      </li>
                    ))}
                  </ul>
                  <Link
                    to="/contact"
                    className={`block w-full py-3.5 text-sm font-semibold rounded-md text-center whitespace-nowrap cursor-pointer transition-all duration-200 ${
                      plan.accent
                        ? 'bg-primary-500 text-background-50 hover:bg-primary-600'
                        : 'border-2 border-background-300 text-foreground-700 hover:border-primary-300 hover:text-primary-600'
                    }`}
                  >
                    {plan.accent ? '今すぐ相談する' : 'まずは相談する'}
                  </Link>
                </div>
              ))}
            </div>

            <p className="text-center text-xs text-foreground-400 mb-16">
              ※ 表示価格はすべて税別です。別途、初期導入費用が発生する場合がございます。
            </p>
          </div>
        </section>

        <section className="w-full py-20 md:py-28 bg-background-100">
          <div className="max-w-3xl mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
              <p className="text-primary-600 text-sm font-medium tracking-widest mb-3">FAQ</p>
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-4">
                よくあるご質問
              </h2>
            </div>
            <div className="flex flex-col gap-4">
              {faqs.map((faq, idx) => (
                <details key={idx} className="group bg-background-50 border border-background-200/70 rounded-lg cursor-pointer">
                  <summary className="flex items-center justify-between px-6 py-4 text-sm font-medium text-foreground-900 list-none">
                    <span>{faq.q}</span>
                    <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform duration-200" />
                  </summary>
                  <div className="px-6 pb-4 text-sm text-foreground-600 leading-relaxed">
                    {faq.a}
                  </div>
                </details>
              ))}
            </div>
          </div>
        </section>

        <section className="w-full py-20 md:py-28 bg-background-50">
          <div className="max-w-xl mx-auto px-4 md:px-6 text-center">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-4">
              プラン選びに迷ったら
            </h2>
            <p className="text-foreground-600 text-sm md:text-base mb-8 leading-relaxed">
              まずは無料相談で御社の課題をお聞かせください。最適なプランをご提案いたします。
            </p>
            <Link
              to="/contact"
              className="inline-block px-8 py-3.5 text-sm font-semibold rounded-md whitespace-nowrap cursor-pointer transition-all duration-200 bg-primary-500 text-background-50 hover:bg-primary-600"
            >
              無料相談を申し込む
            </Link>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
